import { render, staticRenderFns } from "./OrderManagement.vue?vue&type=template&id=287be574&scoped=true&"
import script from "./order-management.js?vue&type=script&lang=js&"
export * from "./order-management.js?vue&type=script&lang=js&"
import style0 from "./OrderManagement.vue?vue&type=style&index=0&id=287be574&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287be574",
  null
  
)

export default component.exports